export default {
  institution: {
    tabs: {
      info: "Informations générales",
      general_info: "Informations générales",
      stats: "Statistiques",
    },
    list: "Accéder à la liste des établissements",
    dashboardLink: "Accéder au tableau de bord de l'établissement",
    active: "Actif",
    archived: "Archivé",
    training_active: "Active",
    training_archived: "Archivée",
    view: "Voir",
    view_training: ({ named }) => `Voir la formation ${named("name")}`,
    no_trainings: "Aucune formation",
    avatar_alt: ({ named }) => `Logo de ${named("name")}`,
    avatar_initials_alt: ({ named }) => `Initiales de ${named("name")}`,
    fields: {
      logo: "Logo",
      name: "Nom",
      siret: "SIRET",
      code_uai: "Code UAI",
      email: "Email",
      phone: "Téléphone",
      address: "Adresse",
      url: "Site web",
      account_number: "N° de compte",
      status: "Statut",
    },
    components: {
      title: "Composantes",
    },
    contacts: {
      title: "Contacts",
      empty: "Aucun contact rattaché",
      unknown_role: "Contact",
      account_active: "Compte actif",
      account_inactive: "Compte inactif",
    },
    stats: {
      coming_soon: "Bientôt disponible",
      export_all_excel: "Exporter tout — Excel",
      export_in_progress: "Export en cours de génération — vous serez notifié dès qu'il sera prêt",
      export_failed: "L'export a échoué.",
      level: {
        danger: "Niveau faible",
        warning: "Niveau moyen",
        success: "Niveau bon",
      },
      calculation_note:
        "<strong>Calcul des statistiques</strong> : taux calculés sur les questionnaires publiés et non archivés." +
        " Un trinôme est complet lorsque les 3 profils (alternant, tuteur, responsable pédagogique) ont accès au livret.",
      table: {
        caption: "Statistiques par formation",
        training: "Formation",
        questionnaires: "Questionnaires",
        skills: "Compétences",
        connections: "Connexions",
        triads: "Trinômes",
      },
      indicators: {
        questionnaire_fill_rate: "Taux de remplissage des questionnaires",
        skill_fill_rate: "Taux de remplissage des compétences",
        user_connection_rate: "Taux de connexion des utilisateurs",
        completed_triads_rate: "Taux de trinômes complétés",
      },
      subcounts: {
        promotions: "promotion(s)",
        active_users: "utilisateurs actifs",
        triads: "trinôme(s)",
      },
    },
    key_figures: {
      title: "Chiffres clés",
      current_year: ({ named }) => `Année en cours ${named("start")}/${named("end")}`,
      tooltip: "Calculé sur les promotions incluant l'année en cours",
    },
    trainings_count: ({ plural }) => plural(["formation", "formations"]),
    promotions_count: ({ plural }) => plural(["promotion", "promotions"]),
    apprentices_count: ({ plural }) => plural(["alternant", "alternants"]),
    active_trainings_count: ({ plural }) => plural(["formation active", "formations actives"]),
    current_promotions_count: ({ plural }) => plural(["promotion en cours", "promotions en cours"]),
    tutors_count: ({ plural }) => plural(["tuteur entreprise", "tuteurs entreprise"]),
  },
};
